import useRequest, { IJustificativaRequest } from '@hooks/useRequest';
import { IClienteEvento } from '@model/ClienteEvento';
import { IClienteEventoStatus } from '@model/ClienteEventoStatus';
import { IClienteEventoTipo } from '@model/ClienteEventoTipo';
import React from 'react';

export function useClienteEventoService () {
    const _request = useRequest();

    const listarTiposAtivos = React.useCallback(() => {
        return _request.get<IClienteEventoTipo[]>(`ClienteEvento/ListarTiposAtivos`);
    }, [_request]);

    const listarStatusAtivos = React.useCallback(() => {
        return _request.get<IClienteEventoStatus[]>(`ClienteEvento/ListarStatusAtivos`);
    }, [_request]);

    const cancelar = React.useCallback((clienteEventoId: number, request: IJustificativaRequest) => {
        return _request.post<IClienteEvento>(`ClienteEvento/Cancelar/${clienteEventoId}`, request);
    }, [_request]);

    return React.useMemo(() => ({
        listarTiposAtivos, listarStatusAtivos, cancelar
    }), [listarTiposAtivos, listarStatusAtivos, cancelar]);
}